define('services/events/template-events',[
    // libs
    'underscore', 'utils',
    // parent
    'src/event-aggregator'
], function(_, U, EventAggregator) {

    var TemplateEvents = _.extend({}, EventAggregator.prototype, {
        templateChange: function(model) {
            this.trigger('template:change', model);
        },

    });

    return TemplateEvents;
});

